import { Button, Column, Form, Grid, Row, TextInput, Tile } from "carbon-components-react";
import { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Padding from "../../components/Padding";
import UIShell from "../../components/UIShell";
import { createSkill } from "../../redux/actions/skillAction";

function SkillFormPage({ isLoading }) {
  const history = useHistory()
  const dispatch = useDispatch()

  const [formContent, setFormContent] = useState({
    skillName: undefined,
  })

  const submitForm = (e) => {
    e.preventDefault()

    dispatch(createSkill(formContent, (_data) => {
      history.push("/skills")
    }))
  }

  return (
    <UIShell breadcrumbs={[
      { name: 'Home', link: "/" },
      { name: 'Skills', link: "/skills" },
      { name: 'Create' }
    ]}>
      <Grid>
        <Row>
          <Column>
            <Tile>
              <Form onSubmit={submitForm}>
                <TextInput
                    autoFocus={true}
                    labelText="Skill Name"
                    value={formContent.skillName}
                    onChange={(v) => setFormContent((_state) => ({
                        ..._state,
                        skillName: v.target.value
                    }))}
                />
                <Padding top="1rem">
                    <Button 
                      disabled={isLoading} 
                      type="submit" 
                      kind="primary"
                    >
                      Save
                    </Button>
                    <Button 
                      onClick={() => history.push("/skills")} 
                      kind="secondary"
                    >
                      Cancel
                    </Button>
                </Padding>
              </Form>
            </Tile>
          </Column>
        </Row>
      </Grid>
    </UIShell>
  )
}

const mapStateToProps = state => {
  return {
    isLoading: state.uxReducer.isLoading
  }
}

export default connect(mapStateToProps)(SkillFormPage)